const _fetch = typeof window === 'undefined' ? require('node-fetch') : window.fetch;
const { serialize } = require('object-to-formdata');

class Request {
  constructor(apiLink) {
    this.apiLink = apiLink;
  }

  request(url, opts, body, failOnError) {
    const req = _fetch(`${this.apiLink}${url}`, {
      headers: {
        'Content-Type': 'application/json',
        'Cross-Origin-Resource-Policy': 'cross-origin',
        ...opts.headers,
      },
      ...opts,
      body,
    });

    return req.then(e => {
      if (failOnError && !e.ok) {
        throw new Error(e.message || 'error');
      }
      return e.json();
    });
  }

  get(url, headers, failOnError) {
    return this.request(
      url,
      {
        method: 'GET',
        headers,
      },
      null,
      failOnError,
    );
  }

  post(url, data, headers) {
    return this.request(
      url,
      {
        method: 'POST',
        headers,
      },
      data,
    );
  }

  postFormData(url, data, opts) {
    const gclid = window.localStorage.getItem('gclid');
    const fbclid = window.localStorage.getItem('fbclid');

    const withUtm = {
      ...data,
      gclid,
      fbclid,
    };

    const body = serialize(withUtm, {
      indices: true,
      nullsAsUndefineds: true,
    });

    const req = _fetch(`${this.apiLink}${url}`, {
      method: 'POST',
      headers: {
        'Cross-Origin-Resource-Policy': 'cross-origin',
        Integration: 'landings',
        'Accept-Language': 'en',
      },
      ...opts,
      body,
    });

    return req.then(res => {
      if (!res.ok) {
        return res.text().then(text => {
          throw new Error(`${res.status}: ${text}`);
        });
      }

      return res.json();
    });
  }
}

module.exports = Request;
